import { QuotedRate } from "@src/types/api";
import type { BolDetailsFormValues } from "@taskpane/components/ltl/bolDetailsFormTypes";

export const UNEXPECTED_ERROR_MESSAGE = "An unexpected error occurred";
export const FTL_ORIGINAL_STORAGE_KEY_PREFIX = "autobidder_ftl_original_";

export function readQuotedRateNumberField(offer: QuotedRate, field: string): number | undefined {
  const v = Reflect.get(offer, field);

  return typeof v === "number" && Number.isFinite(v) ? v : undefined;
}

export const FTL_BOL_FIELD_DEFAULTS: BolDetailsFormValues = {
  originAddress: "",
  originAddress2: "",
  destinationAddress: "",
  destinationAddress2: "",
  shipperName: "",
  consigneeName: "",
  companyName: "",
  pickupOpenTime: "",
  pickupCloseTime: "",
  shipperContact: "",
  shipperPhone: "",
  consigneeContact: "",
  consigneePhone: "",
  shipperNumber: "",
  poNumber: "",
  billOfLadingNote: "",
};

export const DEFAULT_FTL_FORM_DATA = {
  ...FTL_BOL_FIELD_DEFAULTS,
  originZip: "",
  originState: "",
  destinationZip: "",
  destinationState: "",
  pickupDate: "",
  weight: 0,
  equipment: "",
};

export type FtlPanelFormData = typeof DEFAULT_FTL_FORM_DATA;

export function pickBolFormSlice(form: FtlPanelFormData): BolDetailsFormValues {
  return {
    originAddress: form.originAddress,
    originAddress2: form.originAddress2,
    destinationAddress: form.destinationAddress,
    destinationAddress2: form.destinationAddress2,
    shipperName: form.shipperName,
    consigneeName: form.consigneeName,
    companyName: form.companyName,
    pickupOpenTime: form.pickupOpenTime,
    pickupCloseTime: form.pickupCloseTime,
    poNumber: form.poNumber,
    shipperNumber: form.shipperNumber,
    billOfLadingNote: form.billOfLadingNote,
    shipperContact: form.shipperContact,
    shipperPhone: form.shipperPhone,
    consigneeContact: form.consigneeContact,
    consigneePhone: form.consigneePhone,
  };
}

export function serializeFtlFormData(formData: FtlPanelFormData): string {
  return JSON.stringify(formData);
}
